export default __webpack_public_path__ + "6c79e012f3342e184df1c2a8497c3875.png";